import {
  getPools,
  startPool,
  stopPool,
  deletePool,
  createPool,
  getPoolCapacity,
  updatePoolCapacity,
  getPoolHadoop,
  updatePoolHadoop,
  getPoolMySql,
  updatePoolMySql,
  getPool,
  retryCreatePool,
} from "@/apis";

const handleResponse = (response) => {
  if (response?.status?.toLowerCase() === "error") {
    throw new Error(response.error || response.message);
  } else {
    return response.value;
  }
};

export const RESOURCE_TYPE_POOLS = "pools";

export const PoolsDataProvider = {
  getList: async ({ resource, pagination, filters, sorters, meta }) => {
    const response = await getPools();
    const data = response.value;
    return {
      data,
      total: data.length,
    };
  },
  getOne: async ({ id, meta }) => {
    if (!id) {
      return null;
    }
    if (meta?.op === "capacity") {
      const resp = await getPoolCapacity(id);
      return resp.value;
    } else if (meta?.op === "hadoop") {
      const resp = await getPoolHadoop(id);
      return resp.value;
    } else if (meta?.op === "mysql") {
      const resp = await getPoolMySql(id);
      return resp.value;
    } else {
      const resp = await getPool(id);
      return resp.value;
    }
  },
  create: async ({ resource, variables, meta }) => {
    const data = await createPool(variables);
    return { data };
    // if (resp && resp.status === "OK") {
    //   return resp.value;
    // } else {
    //   throw new Error(resp.message);
    // }
  },
  update: async ({ id, variables }) => {
    const { action, data } = variables;
    if (action === "stop") {
      const resp = await stopPool(id);
      return handleResponse(resp);
    } else if (action === "start") {
      const resp = await startPool(id);
      return handleResponse(resp);
    } else if (action === "changeCapacity") {
      const resp = await updatePoolCapacity(id, data);
      return handleResponse(resp);
    } else if (action === "changeHadoop") {
      const resp = await updatePoolHadoop(id, data);
      return handleResponse(resp);
    } else if (action === "changeMySQL") {
      const resp = await updatePoolMySql(id, data);
      return handleResponse(resp);
    } else if (action === "retry") {
      const resp = await retryCreatePool(id);
      return handleResponse(resp);
    }
  },
  deleteOne: async ({ resource, id }) => {
    const resp = await deletePool(id);
    return resp.value;
  },
  getApiUrl: () => {
    throw new Error("Function not implemented.");
  },
};
